import { UsersRound } from 'lucide-react';
import { useIamGroups, useDeleteIamGroup, type IamGroup } from '@/api/s3';
import { IamListPage } from '../IamListPage';

/** IAM groups — list, view (detail), create and delete. */
export function GroupList({ serviceId }: { serviceId: string }) {
  const { data = [], isLoading, isError, refetch } = useIamGroups(serviceId);
  const del = useDeleteIamGroup(serviceId);

  return (
    <IamListPage<IamGroup>
      serviceId={serviceId}
      resource="groups"
      title="Groups"
      description="IAM groups bundle users under a shared set of policies."
      createLabel="Create group"
      entities={data}
      isLoading={isLoading}
      isError={isError}
      refetch={refetch}
      nameOf={(g) => g.group_name}
      dateOf={(g) => g.create_date}
      emptyIcon={<UsersRound size={20} />}
      emptyTitle="No groups yet"
      emptyDescription="Create a group to manage policies for a set of users at once."
      del={del}
      entityLabel="group"
    />
  );
}
